import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/** Layout shell for CDK-based dropdowns. See this folder’s `README.md`. */
@Component({
  selector: 'ps-dropdown',
  standalone: true,
  template: `
    <div class="dropdown" [attr.data-cy]="dataCy()">
      <ng-content></ng-content>
    </div>
  `,
  styles: [
    `
      :host {
        display: var(--ps-cx-dropdown-display, inline-block);
        width: var(--ps-cx-dropdown-width, 100%);
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'ps-dropdown',
  },
})
export class DropdownComponent {
  public readonly dataCy = input.required<string>();
}
